import { Controller } from "stimulus"

const DEFAULT_TIMEOUT_MS = 4000
// Matches the duration-300 transition dismiss() applies.
const FADE_OUT_MS = 300

// Fades out and removes a flash message after data-flash-timeout milliseconds.
// Stimulus 1.1 has no Values API, so the timeout is read from the data map.
// A timeout of 0 keeps the flash on screen until its Dismiss button is clicked.
// The flash is a fixed banner over the header, so dismissing it stops it
// catching clicks at once and removes it as soon as the fade ends.
export default class extends Controller {
  connect() {
    const timeout = this.timeoutMs
    if (timeout > 0) {
      this.timer = setTimeout(() => this.dismiss(), timeout)
    }
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  dismiss() {
    if (!this.element) return

    this.element.classList.add("pointer-events-none", "opacity-0", "translate-y-1", "transition", "duration-300")
    setTimeout(() => {
      if (this.element && this.element.parentNode) {
        this.element.parentNode.removeChild(this.element)
      }
    }, FADE_OUT_MS)
  }

  get timeoutMs() {
    const configured = parseInt(this.data.get("timeout"), 10)
    return Number.isNaN(configured) ? DEFAULT_TIMEOUT_MS : configured
  }
}
